export default class EpgCacheService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getTagsSimpleList(params) {
		return this.apiService.callGet('epgCache/tags_simple', params)
	}

	getCountriesSimpleList(params) {
		return this.apiService.callGet('epgCache/countries_simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/EpgCacheService.js